// extracted by mini-css-extract-plugin
export default {"input":"pr84Rl"};